/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
    path : '/activeResult',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/ActiveResult.jsx').default)
        }, 'active-result')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/activeResult.js